import styled from "styled-components";
import { theme } from "@themes";

export const ButtonUploadFile = styled.div`
  width: fit-content;
  height: 42px;
  padding-right: 1em;
  background-color: ${({ theme }) => theme.neutral.gray[700]};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
`;

export const FileUpload = styled.input`
  visibility: hidden;
  height: 0;
  width: 0;
`;

export const FileName = styled.label`
  text-decoration: underline;
  cursor: pointer;
`;
